import $ from "jquery";

class App.Views.DomainsView extends Backbone.View
  initialize: ->
    view = $(@el)
    view.data('view',this)

    @$('.domain').each ->
      new App.Views.EditDomainView({el: $(this), parent: view})
